import React from 'react';
import { ShinyText } from './animations/ShinyText';
const capabilities = ['Attack-path validation', 'AI-security validation', 'Fix verification', 'Evidence packs', 'MSSP-ready reporting', 'SaaS-style pricing', 'Continuous validation', 'Plain-English remediation', 'Self-serve onboarding', 'Shareable proof'];
export function ProofStrip() {
  const items = [...capabilities, ...capabilities];
  return <div className="relative w-full border-y border-white/5 bg-[#070a0e] py-6 overflow-hidden" data-id="element-1209">
      <div className="fade-mask-x" data-id="element-1210">
        <div className="flex gap-12 animate-marquee whitespace-nowrap" data-id="element-1211">
          {items.map((cap, i) => <div key={i} className="flex items-center gap-3 flex-shrink-0" data-id="element-1212">
              <span className="w-1 h-1 rounded-full bg-[#1a8fd4]" data-id="element-1213" />
              <span className="font-mono text-sm uppercase tracking-widest" data-id="element-1214">
                <ShinyText text={cap} speed={6} data-id="element-1215" />
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}